import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ProductIntro } from './components/ProductIntro';
import { BenefitsStrip } from './components/BenefitsStrip';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { MockupShowcase } from './components/MockupShowcase';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1320212723322841';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || (window as any).fbq) return;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: any, s: any;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', META_PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <ProductIntro data-id="element-3" />
      <BenefitsStrip data-id="element-4" />
      <WhatsInside data-id="element-5" />
      <Bonuses data-id="element-6" />
      <MockupShowcase data-id="element-7" />
      <Pricing data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}